import Client from "../client";

export type ServiceId = number;

export interface Service {
  id: ServiceId;
  name: string;
  code: string;
  availableUsers: number;
  disabled: boolean;
}

export interface UserServiceGateway {
  all(): Promise<Service[]>;
  find(id: ServiceId): Promise<Service | undefined>;
  login(serviceId: ServiceId): Promise<string>;
}

export default class UserServiceApi implements UserServiceGateway {
  public constructor(private client: Client) {}

  /**
   * ログインユーザーが利用できるサービスを得る
   */
  public async all(): Promise<Service[]> {
    const services = await this.client.get("get_user_services.php");
    return services;
  }

  /**
   * 指定されたサービスを得る
   */
  public async find(id: ServiceId): Promise<Service | undefined> {
    const services = await this.all();
    return services.find(s => s.id === id);
  }

  /**
   * サービスを切り替える
   */
  public async login(serviceId: ServiceId): Promise<string> {
    const data = await this.client.get("switch_service.php", { serviceId });
    return data.accessToken;
  }
}
